import { render } from "./ConfirmDialogHost.vue?vue&type=template&id=3489a21b"
import script from "./ConfirmDialogHost.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogHost.vue?vue&type=script&lang=js"

import "./ConfirmDialogHost.vue?vue&type=style&index=0&id=3489a21b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__